import { api, BACKEND_URL } from "./api";
import { act } from "./sales";

export const img = (u) => (u?.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);
export const STAGES = { discovered: "Discovered", researched: "Research complete", ready: "Ready for outreach", contacted: "Contacted", interested: "Interested", onboarding: "Onboarding scheduled",
  registered: "Registered", active: "Active vendor", follow_up: "Needs follow-up", not_interested: "Not interested", dnc: "Do not contact" };
export const panel = "bg-white border border-[var(--line)] rounded-2xl";
export const dur = (s) => (s ? `${Math.floor(s / 60)}m ${String(s % 60).padStart(2, "0")}s` : "—");

// A saved CRM lead → the same shape the research results use.
export function fromProspect(p) {
  const r = p.research || {};
  return { ...p, name: p.business_name, pid: p.prospect_id, prov: r.prov || {}, photos: r.photos || [], socials: r.socials || {}, hours: r.hours || [], description: r.description || "",
    price_range: r.price_range || "", logo: r.logo || "", maps_url: r.maps_url || "", yelp_url: r.yelp_url || "", sources: r.sources || [], in_crm: p.prospect_id, enriched: true };
}

export async function ensureSaved(v, onSaved) {
  if (v.pid || v.in_crm) return v.pid || v.in_crm;
  const r = await act(() => api.post("/admin/vi/save", { result: v }));
  if (!r) return null;
  onSaved?.(r.prospect_id, r.duplicate);
  return r.prospect_id;
}
